import { render, staticRenderFns } from "./SectionRecommend.vue?vue&type=template&id=3cdda70e&scoped=true&lang=pug&"
import script from "./SectionRecommend.vue?vue&type=script&lang=js&"
export * from "./SectionRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SectionRecommend.vue?vue&type=style&index=0&id=3cdda70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdda70e",
  null
  
)

export default component.exports